import type {
  InviteLinkResponse,
  InviteLinksResponse,
  MembersResponse,
  OrganizationResponse,
  OrganizationsResponse,
  OrgRole,
} from '@nargus/shared';
import { request } from '../http';

export interface CreateOrganizationInput {
  name: string;
}

export interface CreateInviteInput {
  organizationId: string;
  role: OrgRole;
}

export interface MemberRef {
  organizationId: string;
  userId: string;
}

export interface InviteRef {
  organizationId: string;
  inviteId: string;
}

export const organizationResource = {
  list: (): Promise<OrganizationsResponse> => request('/organizations'),

  create: (input: CreateOrganizationInput): Promise<OrganizationResponse> =>
    request('/organizations', { method: 'POST', body: JSON.stringify(input) }),

  members: (organizationId: string): Promise<MembersResponse> =>
    request(`/organizations/${organizationId}/members`),

  removeMember: ({ organizationId, userId }: MemberRef): Promise<void> =>
    request(`/organizations/${organizationId}/members/${userId}`, { method: 'DELETE' }),

  invites: (organizationId: string): Promise<InviteLinksResponse> =>
    request(`/organizations/${organizationId}/invites`),

  createInvite: ({ organizationId, role }: CreateInviteInput): Promise<InviteLinkResponse> =>
    request(`/organizations/${organizationId}/invites`, {
      method: 'POST',
      body: JSON.stringify({ role }),
    }),

  revokeInvite: ({ organizationId, inviteId }: InviteRef): Promise<void> =>
    request(`/organizations/${organizationId}/invites/${inviteId}`, { method: 'DELETE' }),
};
